import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'merlin-library';
import { HttpClient } from '@angular/common/http';
import { myAccountModel, LandingPageOption, LANDING_PAGE_OPTIONS, DEFAULT_LANDING_PAGE } from './my-account.model';
import { ContactInfo } from './my-account-contact.model';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';

@Injectable({
  providedIn: 'root',
})
//TODO: Use passed id's.
export class MyAccountService {

  constructor(private apiSer: ApiService, private http: HttpClient) {}

  // Get all available landing page options (for future use in UI)
  getLandingPageOptions(): LandingPageOption[] {
    return LANDING_PAGE_OPTIONS;
  }

   // Get route for a given Landing Page preference or API code
  getRouteForPreference(preference: string | number): string {
    const option = typeof preference === 'number' 
      ? LANDING_PAGE_OPTIONS.find(opt => opt.apiCode === preference)
      : LANDING_PAGE_OPTIONS.find(opt => opt.identifier === preference);
    return option?.route || DEFAULT_LANDING_PAGE.route;
  }

   // Translate API code to internal identifier
  private fromApiCode(code: number | null | undefined): string {
    if (code == null) {
      return DEFAULT_LANDING_PAGE.identifier;
    }
    const option = LANDING_PAGE_OPTIONS.find(opt => opt.apiCode === code);
    return option?.identifier || DEFAULT_LANDING_PAGE.identifier;
  }

   // Translate internal identifier to API code
  private toApiCode(name: string): number {
    const option = LANDING_PAGE_OPTIONS.find(opt => opt.identifier === name);
    return option?.apiCode || DEFAULT_LANDING_PAGE.apiCode;
  }

  view(userId) :  Observable<myAccountModel> {
    return  (this.apiSer.get(ClinicianApiEndPointConstants.myAccountClinicUsers + userId) as Observable<any>).pipe(
      map((res: any) => ({
        ...res,
        landingPagePreferenceCd: this.fromApiCode(res?.landingPagePreferenceCd)
      }))
    );
  }

  changePassword(data){
    return this.apiSer.post(ClinicianApiEndPointConstants.changePassword,data);
  }

  update(id, data) {
    const payload = {
      ...data,
      landingPagePreferenceCd: this.toApiCode(data.landingPagePreferenceCd)
    };
    return this.apiSer.put(ClinicianApiEndPointConstants.myAccountClinicUsers, payload);
  }

  updateContactInfo(id: string,contactInfo : ContactInfo){
    return  this.apiSer.post(ClinicianApiEndPointConstants.userUpdateContact+id,contactInfo);
  }

  getContactInfo(id: string){
    return this.apiSer.get(ClinicianApiEndPointConstants.userGetContact+id);
  }

  emailValidate(payload) {
    return this.apiSer.post(ClinicianApiEndPointConstants.userUniqueEmailCheck(), payload);
}

  getPrimaryEmailDetails(id,email) {
    return this.apiSer.get(ClinicianApiEndPointConstants.userUniqueIDandPrimaryEmailCheck(id, email));
  }
}

